import { Box, Checkbox, CircularProgress, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class ControlAsistenciaConfirmada extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            consultaRealizada: false,
            notificaciones: null,
            errores: null,
            numeroNombre: [],
            datosConsulta: [],
            lugaresTra: [],
            ubicacionesCentral: [],
            consultaEspecifica: false,

            consultaControl: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                ubicacion: '',
                ubicacionCentral: '',
                mes: '',
                anio: '',
            },

            checkControl: {
                todo: true,
                confirmado: false,
                sinConfirmar: false,
            },

            confirmadoConsulta: [],
            sinconFirmarConsulta: [],

            datosConsultaEspe: {},
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarConsultaEspecifica = this.manejarConsultaEspecifica.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarAtrasCon = this.manejarAtrasCon.bind(this);
        this.cambioListadoConsulta = this.cambioListadoConsulta.bind(this);
    }

    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });
    }
    render () {
        return (
            <>
                <Container>
                    <h3>Control de Asistencia Confirmada</h3>
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <br/>
                    <div>
                        {this.state.consultaRealizada ?
                            <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                            </ReactHtmlTableToExcel>
                        :
                            null
                        }
                    </div>
                    <br/>
                    {this.state.consultaRealizada || this.state.consultaEspecifica || this.state.consultaFuncionario
                    ?
                        null
                    :
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Numero Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Ubicación</StyledTableCell>
                                            {this.state.consultaControl.ubicacion === '0' ? <StyledTableCell width={'16%'}>Ubicación Central</StyledTableCell> : null}
                                            <StyledTableCell>Mes</StyledTableCell>
                                            <StyledTableCell>Año</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroFuncionario' value={this.state.consultaControl.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell>{this.state.consultaControl.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacion'  value={this.state.consultaControl.ubicacion} onChange={this.manejarCambiosDatos}>
                                                    <option value=''>UBICACION</option>
                                                    {this.state.lugaresTra.map((name) =>
                                                        <option
                                                        key={name.idLugaresTrabajo}
                                                        value={name.idLugaresTrabajo}
                                                        >{name.lugar}</option>
                                                        )}
                                                </select>
                                            </StyledTableCell>
                                            {this.state.consultaControl.ubicacion === '0' ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionCentral'  value={this.state.consultaControl.ubicacionCentral} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>UBICACION</option>
                                                        {this.state.ubicacionesCentral.map((name) =>
                                                            <option
                                                            key={name.idUbicacionesCentral}
                                                            value={name.idUbicacionesCentral}
                                                            >{name.descripcion}
                                                        </option>
                                                            )}
                                                    </select>
                                                </StyledTableCell> : null
                                            }
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='mes'  value={this.state.consultaControl.mes} onChange={this.manejarCambiosDatos}>
                                                    <option value=''>MES</option>
                                                    <option value={'01'}>ENERO</option>
                                                    <option value={'02'}>FEBRERO</option>
                                                    <option value={'03'}>MARZO</option>
                                                    <option value={'04'}>ABRIL</option>
                                                    <option value={'05'}>MAYO</option>
                                                    <option value={'06'}>JUNIO</option>
                                                    <option value={'07'}>JULIO</option>
                                                    <option value={'08'}>AGOSTO</option>
                                                    <option value={'09'}>SETIEMBRE</option>
                                                    <option value={'10'}>OCTUBRE</option>
                                                    <option value={'11'}>NOVIEMBRE</option>
                                                    <option value={'12'}>DICIEMBRE</option>
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.consultaControl.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Consultar</button></StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    }
                    {this.state.consultaFuncionario
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell align="center" colSpan={9}>{this.state.datosConsulta[0].numeroFuncionario} {this.state.datosConsulta[0].nombreFuncionario}</StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell>Día</StyledTableCell>
                                            <StyledTableCell>Fecha</StyledTableCell>
                                            <StyledTableCell>Entra</StyledTableCell>
                                            <StyledTableCell>Sale</StyledTableCell>
                                            <StyledTableCell>Entra</StyledTableCell>
                                            <StyledTableCell>Sale</StyledTableCell>
                                            <StyledTableCell>Entra</StyledTableCell>
                                            <StyledTableCell>Sale</StyledTableCell>
                                            <StyledTableCell>Observaciones</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosConsulta.map((dato,index) => (
                                            
                                            dato.resumen !== '' ?
                                                    <TableRow key={index}>
                                                        <StyledTableCell colSpan={9}>{dato.resumen}</StyledTableCell>
                                                    </TableRow>
                                            :
                                            <StyledTableRow key={index}>
                                                <StyledTableCell>{dato.diaSemana}</StyledTableCell>
                                                <StyledTableCell>{dato.fecha}</StyledTableCell>
                                                <StyledTableCell>{dato.marca1}</StyledTableCell>
                                                <StyledTableCell>{dato.marca2}</StyledTableCell>
                                                <StyledTableCell>{dato.marca3}</StyledTableCell>
                                                <StyledTableCell>{dato.marca4}</StyledTableCell>
                                                <StyledTableCell>{dato.marca5}</StyledTableCell>
                                                <StyledTableCell>{dato.marca6}</StyledTableCell>
                                                <StyledTableCell>{dato.observaciones}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasCon}>Volver</button>
                        </Container>
                    :
                        null
                    }
                    {this.state.consultaRealizada
                    ?
                        <Container>
                            <FormControlLabel label='Todo' control={<Checkbox checked={this.state.checkControl.todo} onChange={this.cambioListadoConsulta} id='todo'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                            <FormControlLabel label='Confirmado' control={<Checkbox checked={this.state.checkControl.confirmado} onChange={this.cambioListadoConsulta} id='confirmado'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                            <FormControlLabel label='Sin Confirmar' control={<Checkbox checked={this.state.checkControl.sinConfirmar} onChange={this.cambioListadoConsulta} id='sinConfirmar'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        </Container>
                    :
                        null
                    }
                    {
                    this.state.consultaRealizada && this.state.checkControl.todo
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Número Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Mes</StyledTableCell>
                                            <StyledTableCell>Año</StyledTableCell>
                                            <StyledTableCell>Control Realizado</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosConsulta.map((dato,index) => (
                                            <StyledTableRow key={index}>
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.numeroFuncionario}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.nombreFuncionario}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.mes}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.mes}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.anio}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.anio}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.controlConfirmado}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.controlConfirmado}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell><button className="btn btn-blue mx-2" type='button' onClick={() => this.manejarConsultaEspecifica(dato)}>Consultar</button></StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}></StyledTableCell>
                                                }
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasCon}>Volver</button>
                        </Container>
                    :
                        null
                    }

                    {this.state.consultaRealizada && this.state.checkControl.confirmado
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Número Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Mes</StyledTableCell>
                                            <StyledTableCell>Añoo</StyledTableCell>
                                            <StyledTableCell>Control Realizado</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.confirmadoConsulta.map((dato,index) => (
                                            <StyledTableRow key={index}>
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.numeroFuncionario}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.nombreFuncionario}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.mes}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.mes}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.anio}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.anio}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.controlConfirmado}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.controlConfirmado}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell><button className="btn btn-blue mx-2" type='button' onClick={() => this.manejarConsultaEspecifica(dato)}>Consultar</button></StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}></StyledTableCell>
                                                }
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasCon}>Volver</button>
                        </Container>
                    :
                        null
                    }

                    {this.state.consultaRealizada && this.state.checkControl.sinConfirmar
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Número Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Mes</StyledTableCell>
                                            <StyledTableCell>Añoo</StyledTableCell>
                                            <StyledTableCell>Control Realizado</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.sinconFirmarConsulta.map((dato,index) => (
                                            <StyledTableRow key={index}>
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.numeroFuncionario}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.nombreFuncionario}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.mes}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.mes}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.anio}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.anio}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.controlConfirmado}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.controlConfirmado}</StyledTableCell>
                                                }
                                                {dato.controlConfirmado === 'SI'
                                                ?
                                                    <StyledTableCell><button className="btn btn-blue mx-2" type='button' onClick={() => this.manejarConsultaEspecifica(dato)}>Consultar</button></StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}></StyledTableCell>
                                                }
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasCon}>Volver</button>
                        </Container>
                    :
                        null
                    }

                    {this.state.consultaEspecifica
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell align="center" colSpan={9}>{this.state.datosConsultaEspe[0].numeroFuncionario} {this.state.datosConsultaEspe[0].nombreFuncionario}</StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell>Día</StyledTableCell>
                                            <StyledTableCell>Fecha</StyledTableCell>
                                            <StyledTableCell>Entra</StyledTableCell>
                                            <StyledTableCell>Sale</StyledTableCell>
                                            <StyledTableCell>Entra</StyledTableCell>
                                            <StyledTableCell>Sale</StyledTableCell>
                                            <StyledTableCell>Entra</StyledTableCell>
                                            <StyledTableCell>Sale</StyledTableCell>
                                            <StyledTableCell>Observaciones</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosConsultaEspe.map((dato,index) => (
                                            
                                            dato.resumen !== '' ?
                                                    <TableRow key={index}>
                                                        <StyledTableCell colSpan={9}>{dato.resumen}</StyledTableCell>
                                                    </TableRow>
                                            :
                                            <StyledTableRow key={index}>
                                                <StyledTableCell>{dato.diaSemana}</StyledTableCell>
                                                <StyledTableCell>{dato.fecha}</StyledTableCell>
                                                <StyledTableCell>{dato.marca1}</StyledTableCell>
                                                <StyledTableCell>{dato.marca2}</StyledTableCell>
                                                <StyledTableCell>{dato.marca3}</StyledTableCell>
                                                <StyledTableCell>{dato.marca4}</StyledTableCell>
                                                <StyledTableCell>{dato.marca5}</StyledTableCell>
                                                <StyledTableCell>{dato.marca6}</StyledTableCell>
                                                <StyledTableCell>{dato.observaciones}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                        </Container>
                    :
                        null
                    }

                    <br/>
                    <br/>
                </Container>
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            consultaRealizada: false,
        });
        this.setState(state => {
            const numFunActualizado = state.consultaControl;
            numFunActualizado[clave] = valor;
            
            if((clave === 'numeroFuncionario') && (valor !== '') ){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionario'] = '';
                }
                });
            }else if((clave === 'nombreFuncionario') && (valor === '')){
                numFunActualizado['nombreFuncionario'] = '';
            }
            
            return{
                consultaControl: numFunActualizado,
            };
        });
    }

    async manejoEnvioConsulta(){
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
            consultaRealizada: false,
        })
        if((this.state.consultaControl.numeroFuncionario !== '') && (this.state.consultaControl.nombreFuncionario === '')){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido',
            })
        }/*else if(this.state.consultaControl.nombreFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido',
            })
        }*/else if(this.state.consultaControl.mes === ''){
            this.setState({
                errores: 'Debe ingresar el mes de la consulta',
            })
        }else if(this.state.consultaControl.anio === ''){
            this.setState({
                errores: 'Debe ingresar el año de la consulta',
            })
        }else{
            this.setState({
                loading: true,
                errores: null,
                notificaciones: null,
            });
            const cargaUtil = JSON.stringify([this.state.consultaControl]);

            /*const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_controlAsistencia.php`,{
                method: 'POST',
                body: cargaUtil,
            })*/

            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_controlAsistenciaConfirmada.php`,{
                method: 'POST',
                body: cargaUtil,
            })

            const exito = await respuesta.json();
            this.setState({
                errores: exito[0],
                loading: false,
            })
            if((exito[4] === 'no') && (exito[3] === 1)){
                this.setState({
                    loading: false,
                    errores: null,
                    notificaciones: null,
                    datosConsulta: exito[1],
                    consultaFuncionario: true,
                })
            }else if(((exito[4] === 'si'))){
                this.setState({
                    datosConsulta: exito[1],
                    consultaRealizada: true,
                    notificaciones: false,
                    errores: false,
                    confirmadoConsulta: exito[5],
                    sinconFirmarConsulta: exito[6],
                })
            }
        }
    }

    manejarConsultaEspecifica(dato){
        this.setState({
            consultaEspecifica: true,
            datosConsultaEspe: dato.control,
            notificaciones: null,
            errores: null,
            consultaRealizada: false,
        });
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            consultaEspecifica: false,
            consultaRealizada: true,
            datosConsultaEspe: {},
        })
    }

    manejarAtrasCon(e){
        e.preventDefault();
        this.setState({
            consultaEspecifica: false,
            consultaRealizada: false,
            consultaFuncionario: false,
            datosConsultaEspe: {},
            datosConsulta: [],

            consultaControl: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                ubicacion: '',
                ubicacionCentral: '',
                mes: '',
                anio: '',
            },
        })
    }

    cambioListadoConsulta(e){
        const clave = e.target.id;
        let valor = e.target.checked;
        this.setState({
            errores: null,
            notificaciones: null,
        });

        if(clave === 'todo'){

            if(valor){
                this.setState({
                    checkControl: {
                        todo: true,
                        confirmado: false,
                        sinConfirmar: false,
                    },
                });
            }
        }else if(clave === 'confirmado'){
            if(valor){
                this.setState({
                    checkControl: {
                        todo: false,
                        confirmado: true,
                        sinConfirmar: false,
                    },
                });
            }
        }else if(clave === 'sinConfirmar'){
            if(valor){
                this.setState({
                    checkControl: {
                        todo: false,
                        confirmado: false,
                        sinConfirmar: true,
                    },
                });
            }
        }
    }
}

export default ControlAsistenciaConfirmada